import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { UserService } from '../../User/user.service';
@Injectable()
export class OnboardingGuard implements CanActivate {

  constructor(private userService: UserService) { }
  currentUser: any;
  currentOnboardingTasks: any;
  currentTaskToDo: any;
  // this call is activated for routes that cant be used unless all onboarding is complete
  canActivate() {

    return this.userService.promiseUserObject().then(userObject => {
      this.currentUser = userObject;
      this.currentOnboardingTasks = userObject.req_onboarding;
      this.currentTaskToDo = userObject.req_onboarding[0];

      // try to implement payment guard here..

      switch (this.currentTaskToDo) {
        case 'onboard_email':
          this.onboardEmail();
          return true;
        case 'onboard_group':
          return true;
        default:
          return true;
      }
    });
  }

  onboardEmail() {
    this.userService.openEmailVerificationDialog();
  }

  // returns true if user is on their way to finalizing a group
  // returns false if they just messing around
  inProcessOfGrouping(currentUrl) {
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/Guards/Onboarding/onboarding-guard.component.ts